import Grid, { GridProps } from '@mui/material/Grid'

export const GridCol = (props: GridProps) => (
	<Grid item xs={12} {...props}></Grid>
)
